import { Spacing } from '@persona-id/design-tokens';
import { FC } from 'react';

import { ModalBody, ModalContainer, ModalHeader } from 'dashboard/layouts/ModalLayout';
import Button from 'design-system/components/Button';
import Spacer from 'design-system/components/Spacer';
import { HStack } from 'design-system/components/Stack';
import { Paragraph } from 'design-system/components/Text';

interface WorkflowsSimulateEnvironmentSwitchModalProps {
  handleCancel: () => void;
  handleConfirm: (() => void) | (() => Promise<void>);
}

const WorkflowsSimulateEnvironmentSwitchModal: FC<WorkflowsSimulateEnvironmentSwitchModalProps> = ({
  handleCancel,
  handleConfirm,
}) => {
  return (
    <ModalContainer data-test='confirmation-modal' size='md'>
      <ModalHeader data-test='confirmation-modal__header' onClose={handleCancel}>
        Switch environments?
      </ModalHeader>

      <ModalBody>
        <Paragraph data-test='confirmation-modal__message'>
          The workflow run was created in a different environment. You can view the workflow run by
          switching environments.
        </Paragraph>

        <Spacer height={4} />

        <HStack equal={true} spacing={Spacing[4]}>
          <Button
            autoFocus={true}
            id='confirmation-modal__cancel'
            data-test='confirmation-modal__cancel'
            variant='basic'
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            id='confirmation-modal__confirm'
            data-test='confirmation-modal__confirm'
            variant='danger'
            onClick={handleConfirm}
          >
            Yes
          </Button>
        </HStack>
      </ModalBody>
    </ModalContainer>
  );
};

export default WorkflowsSimulateEnvironmentSwitchModal;
